import { getProxycadorHost } from "environment";

const urlWithPlaylistType = (playlistType) => (streamId) =>
  `${getProxycadorHost()}/proxycador/api/live/stream/v1/playlist?playlistType=${playlistType}&streamId=${streamId}`;

export const liveUrl = urlWithPlaylistType("live");
export const masterUrl = urlWithPlaylistType("master");
export const previewUrl = urlWithPlaylistType("preview");
